"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfOrientationOpportunityDocumentDto = instanceOfOrientationOpportunityDocumentDto;
exports.OrientationOpportunityDocumentDtoFromJSON = OrientationOpportunityDocumentDtoFromJSON;
exports.OrientationOpportunityDocumentDtoFromJSONTyped = OrientationOpportunityDocumentDtoFromJSONTyped;
exports.OrientationOpportunityDocumentDtoToJSON = OrientationOpportunityDocumentDtoToJSON;
exports.OrientationOpportunityDocumentDtoToJSONTyped = OrientationOpportunityDocumentDtoToJSONTyped;
/**
 * Check if a given object implements the OrientationOpportunityDocumentDto interface.
 */
function instanceOfOrientationOpportunityDocumentDto(value) {
    if (!('href' in value) || value['href'] === undefined)
        return false;
    if (!('mimeType' in value) || value['mimeType'] === undefined)
        return false;
    if (!('orientationOpportunityId' in value) || value['orientationOpportunityId'] === undefined)
        return false;
    if (!('storedDocumentId' in value) || value['storedDocumentId'] === undefined)
        return false;
    if (!('fileName' in value) || value['fileName'] === undefined)
        return false;
    return true;
}
function OrientationOpportunityDocumentDtoFromJSON(json) {
    return OrientationOpportunityDocumentDtoFromJSONTyped(json, false);
}
function OrientationOpportunityDocumentDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'href': json['href'],
        'mimeType': json['mimeType'],
        'orientationOpportunityId': json['orientationOpportunityId'],
        'storedDocumentId': json['storedDocumentId'],
        'fileName': json['fileName'],
    };
}
function OrientationOpportunityDocumentDtoToJSON(json) {
    return OrientationOpportunityDocumentDtoToJSONTyped(json, false);
}
function OrientationOpportunityDocumentDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'href': value['href'],
        'mimeType': value['mimeType'],
        'orientationOpportunityId': value['orientationOpportunityId'],
        'storedDocumentId': value['storedDocumentId'],
        'fileName': value['fileName'],
    };
}
//# sourceMappingURL=OrientationOpportunityDocumentDto.js.map